"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function makeCancellablePromise(promise) {
    var isCancelled = false;
    var wrappedPromise = new Promise(function (resolve, reject) {
        promise
            .then(function (value) { return !isCancelled && resolve(value); })
            .catch(function (error) { return !isCancelled && reject(error); });
    });
    return {
        promise: wrappedPromise,
        cancel: function () {
            isCancelled = true;
        },
    };
}
exports.default = makeCancellablePromise;



//////////////////
// WEBPACK FOOTER
// ./~/make-cancellable-promise/dist/cjs/index.js
// module id = 60
// module chunks = 0